import { render, staticRenderFns } from "./FtthCappedPricing.vue?vue&type=template&id=b67715d6&scoped=true&"
import script from "./FtthCappedPricing.vue?vue&type=script&lang=js&"
export * from "./FtthCappedPricing.vue?vue&type=script&lang=js&"
import style0 from "./FtthCappedPricing.vue?vue&type=style&index=0&id=b67715d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67715d6",
  null
  
)

export default component.exports